import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIConstants } from '../../../../_config/restapis';
import { map } from 'rxjs/operators';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Constants } from '../../../../_utils/Constants';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class GstRegistrationService {

    constructor(
        private http: HttpClient,
        private db: $DBManagerService,
        private evt: $BroadcastManagerService
    ) { }
	public GetNewgstRegistration(EntityID): Observable<any> {
        return this.http.post(APIConstants.GETNEWGSTREGISTRATION, EntityID);

   }
    public newgstRegistration(data): Observable<any> {
        return this.http.post(APIConstants.NEWGSTREG, data);

    }
	
	 public verifyRegistration(GSTNumber): Observable<any> {
        return this.http.post(APIConstants.VERIFYGSTREG, {"Entity_GST_Id": GSTNumber});

    }
	public getGstregistrationSearchDetails(data): Observable<any> {
        return this.http.post(APIConstants.GSTREGISTRATIONSEARCHDETAILS, data);

    }
	 public exportGstSearchCSV(data): Observable<any> {
        return this.http.post(APIConstants.DOWNLOADGSTSEARCHEXCEL, data, { responseType: "blob" });
    }
	
	public getGstRegistrationWorklist(data): Observable<any> {
        return this.http.post(APIConstants.WORKLIST, data);
	}
	
	 public exportGstWorklistCSV(data): Observable<any> {
        return this.http.post(APIConstants.DOWNLOADGSTWORKLISTEXCEL, data, { responseType: "blob" });
    }
	
	public downloadGSTReportCsv(data): Observable<any> {
        return this.http.post(APIConstants.DOWNLOADGSTREPORTEXCEL, data, { responseType: "blob" });
    }
	
    public getGSTNumbersByEntityID(entityID): Observable<any> {
        return Observable.of([
            "03AAACT2438A1Z3",
            "02AAACT2438A1Z5",
            "03AAACT2438A1Z3",
            "04AAACT2438A1Z1",
            "05AAACT2438A1ZZ",
            "06AAACT2438A2ZW",
            "07AAACT2438A1ZV",
            "08AAACT2438A1ZT",
            "09AAACT2438A1ZR",
            "10AAACT2438A1Z8",
            "11AAACT2438A1Z6",
            "12AAACT2438A1Z4",
            "13AAACT2438A1Z2",
            "14AAACT2438A1Z0",
            "15AAACT2438A1ZY",
            "16AAACT2438A1ZW",
            "17AAACT2438A1ZU",
            "18AAACT2438A1ZS",
            "19AAACT2438A1ZQ",
            "20AAACT2438A1Z7",
            "21AAACT2438A1Z5",
            "22AAACT2438A1Z3",
            "23AAACT2438A1Z1",
            "24AAACT2438A1ZZ",
            "24AAACT2438A1ZZ",
            "24AAACT2438A1ZZ",
            "27AAACH1458C1ZZ",
            "27AAACT2438A1ZT",
            "29AAACT2438A1ZP",
            "27AAACT2438A1ZT",
            "30AAACH1458C1ZC",
            "32AAACT2438A1Z2",
            "32AAACT2438A1Z2",
            "33AAACT2438A1Z0",
            "34AAACT2438A1ZY",
            "36AAACT2438A1ZU",
            "37AAACT2438A1ZS"

        ])

    }
    public getstates(): any[] {
        return [
            { 'stateid': 1, 'statename': 'JAMMU AND KASHMIR' }
            , { 'stateid': 2, 'statename': 'HIMACHAL PRADESH' }
            , { 'stateid': 3, 'statename': 'PUNJAB' }
            , { 'stateid': 4, 'statename': 'CHANDIGARH' }
            , { 'stateid': 5, 'statename': 'UTTARAKHAND' }
            , { 'stateid': 6, 'statename': 'HARYANA' }
            , { 'stateid': 7, 'statename': 'DELHI' }
            , { 'stateid': 8, 'statename': 'RAJASTHAN' }
            , { 'stateid': 9, 'statename': 'UTTAR PRADESH' }
            , { 'stateid': 10, 'statename': 'BIHAR' }
            , { 'stateid': 11, 'statename': 'SIKKIM' }
            , { 'stateid': 12, 'statename': 'ARUNACHAL PRADESH' }
            , { 'stateid': 13, 'statename': 'NAGALAND' }
            , { 'stateid': 14, 'statename': 'MANIPUR' }
            , { 'stateid': 15, 'statename': 'MIZORAM' }
            , { 'stateid': 16, 'statename': 'TRIPURA' }
            , { 'stateid': 17, 'statename': 'MEGHALAYA' }
            , { 'stateid': 18, 'statename': 'ASSAM' }
            , { 'stateid': 19, 'statename': 'WEST BENGAL' }
            , { 'stateid': 20, 'statename': 'JHARKHAND' }
            , { 'stateid': 21, 'statename': 'ODISHA' }
            , { 'stateid': 22, 'statename': 'CHATTISGARH' }
            , { 'stateid': 23, 'statename': 'MADHYA PRADESH' }
            , { 'stateid': 24, 'statename': 'GUJARAT' }
            , { 'stateid': 26, 'statename': 'DADRA NAGARHAVELI DAMAN DIU' }
            //, { 'stateid': 25, 'statename': 'Daman and Diu' }
            // , { 'stateid': 26, 'statename': 'Dadra and Nagar Haveli' }
            , { 'stateid': 27, 'statename': 'MAHARASHTRA' }
            , { 'stateid': 29, 'statename': 'KARNATAKA' }
            , { 'stateid': 30, 'statename': 'GOA' }
            , { 'stateid': 31, 'statename': 'LAKSHADWEEP' }
            , { 'stateid': 32, 'statename': 'KERALA' }
            , { 'stateid': 33, 'statename': 'TAMIL NADU' }
            , { 'stateid': 34, 'statename': 'PUDUCHERRY' }
            , { 'stateid': 35, 'statename': 'ANDAMAN AND NICOBAR' }
            , { 'stateid': 36, 'statename': 'TELANGANA' }
            , { 'stateid': 37, 'statename': 'ANDHRA PRADESH' }]
    }
	
	public GetgstRegistrationDetails(URN): Observable<any> {
        return this.http.post(APIConstants.GSTDETAILS, {"URN":URN});
    }
	
	public GetgstRegistrationAction(URN): Observable<any> {
        return this.http.post(APIConstants.GSTGETACTION, {"URN":URN});

    }

    public ModifygstRegistration(data): Observable<any> {
        return this.http.post(APIConstants.MODIFYGSTREG, data);
    }
    
	public PostApproverAction(data): Observable<any> {
        return this.http.post(APIConstants.GSTREGISTRATIONACTION, data);

    }

    public checkStatus(URN): Observable<any> {
        return this.http.post(APIConstants.CHECKSTATUS, {"URN":URN});

    }
	
	public GetRegistrationDetails(EntityID): Observable<any> {
        return this.http.post(APIConstants.REGISTRATIONDETAILS, EntityID);

    }
	
	public getGstRegistrationReport(data): Observable<any> {
        return this.http.post(APIConstants.GSTREPORTDETAILS, data);

    }
	
		
    public downloadGSTCert(data): Observable<any> {
        return this.http.post(APIConstants.GSTCERTIFICATE, {URN:data}, { responseType: "blob" });
    }
	
	public downloadGSTCertificate(data): Observable<any> {
        return this.http.post(APIConstants.DOWNLOADGSTCERTIFICATE, {RefNo:data}, { responseType: "blob" });
    }
	
	public downloadGSTtFile(data): Observable<any> {
        return this.http.post(APIConstants.DOWNLOADCONSENTFILE,data,{responseType: "blob"});

    }

	public downloadCBGFile(data): Observable<any> {
        return this.http.post(APIConstants.CBGFILEDOWNLOAD,{URN:data},{responseType: "blob"});

    }
    
    
	
	
	
}


